import { useStorage } from '@vueuse/core'

import type { dashboardStatisticsInterface } from '../types/dashboard'
import type { RouteLocationNormalized } from 'vue-router'

const duplicateContestItem = useStorage('contest', {}, sessionStorage)
const dashboardItem = useStorage('dashboard', {} as dashboardStatisticsInterface, sessionStorage)
const forgotPasswordEmail = useStorage('forgotPasswordEmail', '', sessionStorage)
const originalRoute = useStorage('originalRoute', {} as RouteLocationNormalized, sessionStorage)

export default function useSessionStorage() {
  const isEmptyDuplicateContestItem = computed(() => Object.keys(duplicateContestItem.value).length === 0)

  return {
    isEmptyDuplicateContestItem,
    duplicateContestItem,
    dashboardItem,
    forgotPasswordEmail,
    originalRoute
  }
}
